export const paulOmodeiQuestion1 = ``;
export const paulOmodeiQuestion2 = ``;
export const paulOmodeiQuestion3 = ``;
export const paulOmodeiQuestion4 = ``;
